import {
  cnnvdRegExp,
  cnvdRegExp,
  cveRegExp,
  domainRegExp,
  emailRegExp,
  ipv4RegExp,
  matchCertQuery,
  md5RegExp,
  sha1RegExp,
  sha256RegExp,
  sha512RegExp,
  urlRegExp
} from '@/utils/reg-exp'

import { ElMessage } from 'element-plus'
import { router } from '@/router'

export function toIntel (inputString: string, isBlank = false) {
  matchIntelPage(inputString, isBlank).catch(() => {
    ElMessage.error('未知IOC类型。目前支持匹配文件MD5、文件SHA1、文件SHA256、域名、IP地址和URL')
  })
}

export function matchIntelPage (inputString: string, isBlank = false) {
  // eslint-disable-next-line consistent-return,complexity
  return new Promise((resolve, reject) => {
    if (
      md5RegExp.test(inputString) ||
      sha1RegExp.test(inputString) ||
      sha256RegExp.test(inputString) ||
      sha512RegExp.test(inputString)
    ) {
      toIntelPage(`https://ti.mingting.cn/result-file?hash=${inputString}`, isBlank)
      return resolve(true)
    }

    if (emailRegExp.test(inputString)) {
      toIntelPage(`https://ti.mingting.cn/result-email?email=${inputString}`, isBlank)
      return resolve(true)
    }

    if (ipv4RegExp.test(inputString)) {
      toIntelPage(`https://ti.mingting.cn/result-ip?host=${inputString}`, isBlank)
      return resolve(true)
    }

    if (urlRegExp.test(inputString)) {
      toIntelPage(`https://ti.mingting.cn/result-url?link=${encodeURIComponent(inputString)}`, isBlank)
      return resolve(true)
    }

    if (domainRegExp.test(inputString)) {
      toIntelPage(`https://ti.mingting.cn/result-domain?host=${inputString}`, isBlank)
      return resolve(true)
    }

    if (
      cnnvdRegExp.test(inputString) ||
      cveRegExp.test(inputString) ||
      cnvdRegExp.test(inputString)
    ) {
      inputString = inputString.toUpperCase()
      toIntelPage(`https://ti.mingting.cn/result-leak?leak=${inputString}`, isBlank)
      return resolve(true)
    }

    if (matchCertQuery(inputString)) {
      toIntelPage(`https://ti.mingting.cn/result-cert?hash=${matchCertQuery(inputString)}`, isBlank)
      return resolve(true)
    }

    reject(new Error('对象key无法匹配'))
  })
}

function toIntelPage (targetPath: string, isBlank = false) {
  window.open(targetPath)

  // const path = window.location.pathname
  //
  // if (isBlank) {
  //   window.open(targetPath)
  // } else if (targetPath.split('?')[0] === path) {
  //   // 路径一样时，vue路由不跳转，所以用location.href发起跳转
  //   window.location.href = targetPath
  // } else {
  //   router.push(targetPath)
  // }
}
